import React from 'react';
import { Coffee, AlignLeft, Clock } from 'lucide-react';

/**
 * Секция для настройки предпочтений по питанию и диетам
 */
const DietPreferencesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Coffee className="w-5 h-5 mr-2 text-emerald-500" />
        Предпочтения по питанию
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип диеты */}
        <div>
          <label htmlFor="specificDiet" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <AlignLeft className="w-4 h-4 mr-2 text-emerald-500" />
            Тип диеты
          </label>
          <select
            id="specificDiet"
            name="specificDiet"
            value={formData.specificDiet}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="none">Сбалансированное питание (стандарт)</option>
            <option value="keto">Кетогенная диета (низкоуглеводная)</option>
            <option value="lowfat">Низкожировая диета</option>
            <option value="vegetarian">Вегетарианская диета</option>
            <option value="vegan">Веганская диета</option>
          </select>
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Влияет на рекомендуемые пропорции макронутриентов
          </p>
        </div>

        {/* Частота приемов пищи */}
        <div>
          <label htmlFor="mealFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-emerald-500" />
            Приемов пищи в день
          </label>
          <select
            id="mealFrequency"
            name="mealFrequency"
            value={formData.mealFrequency}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="3">3 приема пищи</option>
            <option value="4">4 приема пищи</option>
            <option value="5">5 приемов пищи</option>
            <option value="6">6 приемов пищи</option>
          </select>
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Для оптимального распределения калорий
          </p>
        </div>

        {/* Желаемая скорость изменения веса */}
        {(formData.goal === 'lose' || formData.goal === 'lose_fast' || formData.goal === 'gain' || formData.goal === 'gain_fast') && (
          <div>
            <label htmlFor="weightChange" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              {formData.goal.includes('lose') ? 'Желаемая скорость похудения' : 'Желаемая скорость набора'}
            </label>
            <select
              id="weightChange"
              name="weightChange"
              value={formData.weightChange}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              <option value="0.25">0.25 кг в неделю (медленно)</option>
              <option value="0.5">0.5 кг в неделю (рекомендуется)</option>
              <option value="0.75">0.75 кг в неделю (быстро)</option>
              <option value="1">1 кг в неделю (очень быстро)</option>
            </select>
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              {formData.goal.includes('lose') 
                ? 'Рекомендуется терять не более 0.5-1% от массы тела в неделю' 
                : 'Рекомендуется набирать не более 0.25-0.5% от массы тела в неделю'}
            </p>
          </div>
        )}

        {/* История диет */}
        <div>
          <label htmlFor="dietHistory" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            История диет
          </label>
          <select
            id="dietHistory"
            name="dietHistory"
            value={formData.dietHistory}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="none">Нет особой истории диет</option>
            <option value="yo-yo">Многократные циклы похудения и набора ("эффект йо-йо")</option>
            <option value="long-deficit">Длительное ограничение калорий (более 3 месяцев)</option>
            <option value="intermittent">Практикую интервальное голодание</option>
          </select>
        </div>
      </div>

      <div className="mt-4 bg-emerald-100 dark:bg-emerald-900/30 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800">
        <div className="flex items-start">
          <Coffee className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-1">
              Баланс питательных веществ
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400">
              На основе ваших данных мы рассчитаем не только калории, но и оптимальный баланс белков, жиров и углеводов для достижения ваших целей. Эти рекомендации будут основаны на выбранном типе диеты и научных исследованиях.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DietPreferencesSection;